export default class NoiseInput {
  adcBandwidth;

  constructor(args) {
    if (args) {
      this.adcBandwidth = args.adcBandwidth ?? null;
    }
  }
}
